import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getSunActiveCategoryAction } from '../../../services/request';
import { SunActiveCategoryList } from './sunactive-category/SunActiveCategoryList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const SunActiveCategoryRecord = () => {
  const [search, setSearch] = React.useState(null);
  // const { loading, payload, error } = useQuery(getBonusesAction(search, 'GET'));
  const { loading, payload, error } = useQuery(getSunActiveCategoryAction(search, 'GET'));
  const { loading: optionsLoading, payload: optionsPayload, error: optionsError } = useQuery(getSunActiveCategoryAction(null, 'OPTIONS'));

  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [sunActiveCategories, setSunActiveCategories] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [choices, setChoices] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setSunActiveCategories(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsError && !optionsLoading) {
      setChoices(optionsPayload.actions.GET.choices);
    }
  }, [optionsLoading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setSunActiveCategories(
        _.map(sunActiveCategories, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setSunActiveCategories(_.filter(sunActiveCategories, obj => obj.id !== obj2.id));
    } else {
      setSunActiveCategories([obj2, ...sunActiveCategories]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <SunActiveCategoryList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        sunActiveCategories={sunActiveCategories}
        setSunActiveCategories={setSunActiveCategories}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        choices={choices}
      />
    </>
  );
};
